interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  accent?: boolean;
}

export default function SectionHeading({ title, subtitle, action, accent }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span
          className={`h-8 w-1 rounded-full ${accent ? "bg-accent-500" : "bg-primary-500"}`}
          aria-hidden="true"
        ></span>
        <div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}